import apiClient from "./apiClient";

const axiosRequest = async (
  route,
  method = "GET",
  data = null,
  contentType = "application/json",
  customHeaders = {},
  onUploadProgress = null
) => {
  const isFormData =
    typeof FormData !== "undefined" && data instanceof FormData;

  const headers = { ...customHeaders };
  if (!isFormData) {
    headers["Content-Type"] = contentType;
  }

  const config = {
    method: method,
    headers,
    data: data,
    url: route,
    onUploadProgress,
  };

  const response = await apiClient.request(config);
  return response;
};

export default axiosRequest;
